// @flow
import * as React from 'react'
import BaseField from '../../core/BaseField'
import Input from '../../core/Input'

// Types
import type { Props as BaseFieldProps } from '../../core/BaseField'

export type Props = BaseFieldProps

/**
 * Flexible text input component. Please do not add more
 * prop types and use only the existing ones. If you need
 * some really custom apperance just add another `type` and
 * implement it in CSS.
 * @param  {Object} props
 * @return {React.Element}
 */
const TextField = (props: Props) => (
  <BaseField {...props} renderInput={inputProps => <Input {...inputProps} />} />
)
TextField.defaultProps = {
  ...BaseField.defaultProps,
  type: 'text',
}

export default TextField
